<div class="container contentHeight backgroundWhiteRound">
  <div class="filtre" *ngIf="Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(this.role)">
    <form [formGroup]="Form">
      <mat-form-field class="country">
        <mat-label>{{'scaleform.pays'|translate}}</mat-label>
        <mat-select formControlName="country" required (selectionChange)="getCtcByCountry()">
          <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="DR" *ngIf="showDR && Form.value.country != '' && formCountry">
        <mat-label *ngIf="formCountry.toLowerCase() == 'france'">{{'manageaccount.DR'|translate}}</mat-label>
        <mat-label *ngIf="formCountry.toLowerCase() == 'united kingdom'">{{'manageaccount.country'|translate}}</mat-label>
        <mat-label *ngIf="formCountry.toLowerCase() == 'spain'">{{'manageaccount.region'|translate}}</mat-label>
        <mat-select formControlName="region" (selectionChange)="searchCustomer()">
          <mat-option *ngFor="let region of regions" value="{{region.region}}"> {{region.region|translate}} </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="ctc" *ngIf="Form.value.country != ''">
        <mat-label>{{'manageaccount.ctcName'|translate}}</mat-label>
        <mat-select formControlName="ctc" (selectionChange)="selectCTC($event)">
          <mat-option *ngFor="let ctc of ctcsLstDD" value="{{ctc.idCtc}}"> {{ctc.name}} {{ctc.firstname}} </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div *ngIf="(Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role)) && Form.value.country == ''">
    <mat-table class="table bg-white" matSort [dataSource]="countriesSource" (matSortChange)="sortCountries($event,'1')" *ngIf="drOpen">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">{{res.country | translate}}</mat-cell>
        <mat-footer-cell *matFooterCellDef> {{'manageaccount.total'|translate}} </mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="nbCreated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountCreated'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">{{res.nbAccountCreated}}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="footercell"> {{getTotalAccountCreatedbyCountry()}} </mat-footer-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="nbSent">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountActivated'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">{{res.nbAccountActivated}}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="footercell"> {{getTotalAccountActivatedbyCountry()}} </mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumnsDRinfo; sticky:true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsDRinfo"></mat-row>
      <mat-footer-row *matFooterRowDef="displayedColumnsDRinfo; sticky: true"></mat-footer-row>
    </mat-table>
  </div>
  <div *ngIf="(Utils.isAdminLacour(role) || Utils.isAdminRenault(role) || Utils.isAdminRenaultPays(role) || Utils.isRT(role) || Utils.isFormateur(role) || Utils.isMCI(this.role)) && Form.value.country != ''">
    <div *ngIf="Form.value.ctc == ''">
      <div class="ctcListTable" (click)="OpenCtcTable()"><label class="mt-2">{{'manageaccount.ctcList'|translate}}</label><i  aria-hidden="true" *ngIf="ctcOpen" class="fas fa-chevron-down"></i><i  aria-hidden="true" *ngIf="!ctcOpen" class="fas fa-chevron-up"></i></div>
      <mat-table class="table bg-white" matSort [dataSource]="ctcsSource" (matSortChange)="sortCtc($event,'1')" *ngIf="ctcOpen">
        <ng-container matColumnDef="name" class="ctcName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="ctcName">{{'scaleform.nom'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res" class="ctcName">{{res.name}}</mat-cell>
          <mat-footer-cell *matFooterCellDef> {{'manageaccount.total'|translate}} </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="firstName" class="ctcFirstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="ctcFirstName">{{'scaleform.prenom'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res" class="ctcFirstName">{{res.firstname}}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="nbCreated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountCreated'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.stats.nbAccountCreated}}</mat-cell>
          <mat-footer-cell *matFooterCellDef class="footercell"> {{getTotalAccountCreated()}} </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="nbSent">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountActivated'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.stats.nbAccountActivated}} / {{res.stats.nbAccountTotal}}</mat-cell>
          <mat-footer-cell *matFooterCellDef class="footercell"> {{getTotalAccountActivated()}} / {{getTotalAccountTotal()}}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="histo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.histoActivation'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.compteurHisto}}</mat-cell>

          <mat-footer-cell *matFooterCellDef class="footercell">  </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumnsCTCinfo; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsCTCinfo"></mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumnsCTCinfo; sticky: true"></mat-footer-row>
      </mat-table>

      <hr class="col-10 mx-auto">
    </div>

    <div *ngIf="regions.length>1 && ((Form.controls['region'].value && Form.controls['region'].value.indexOf('manageaccount') >= 0) || Form.value.region == '')">
      <div class="drListTable" (click)="OpenDrTable()"><label class="mt-2">{{'manageaccount.DRList'|translate}}</label><i  aria-hidden="true" *ngIf="drOpen" class="fas fa-chevron-down"></i><i  aria-hidden="true" *ngIf="!drOpen" class="fas fa-chevron-up"></i></div>
      <mat-table class="table bg-white" matSort [dataSource]="drsSource" (matSortChange)="sortDR($event,'1')" *ngIf="drOpen">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.region}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nbCreated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountCreated'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.nbAccountCreated}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nbSent">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.nbAccountActivated'|translate}}</mat-header-cell>
          <mat-cell *matCellDef="let res">{{res.nbAccountActivated}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumnsDRinfo; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsDRinfo"></mat-row>
      </mat-table>

      <hr class="col-10 mx-auto">
    </div>
  </div>

  <div *ngIf="Form.value.country != '' || (Utils.isCTC(role) && !Utils.isAdminLacour(role) && !Utils.isAdminRenault(role) && !Utils.isAdminRenaultPays(role) && !Utils.isRT(role) && !Utils.isFormateur(role) && !Utils.isMCI(role))">
    <div class="colorUserListTable" (click)="OpenColorUserTable()"><label class="mt-2">{{'manageaccount.colorUserList'|translate}}</label><i  aria-hidden="true" *ngIf="colorUserOpen" class="fas fa-chevron-down"></i><i  aria-hidden="true" *ngIf="!colorUserOpen" class="fas fa-chevron-up"></i></div>
    <mat-table class="table lstclients bg-white table-hover customers" matSort [dataSource]="customersSource" (matSortChange)="sortCustomer($event,'1')" *ngIf="colorUserOpen">
      <ng-container matColumnDef="companySocialReason">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.raisonsociale'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res" class="socialReason">{{res.socialReason}}</mat-cell><!--(click)="SelectCustomer(res)"-->
      </ng-container>

      <ng-container matColumnDef="address">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.adresse'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res" class="address">
          <!--(click)="SelectCustomer(res)"-->
          <div class="address">
            <span>{{res.address}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.ville'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res" class="address">
          <!--(click)="SelectCustomer(res)"-->
          <div class="city">
            <span>{{res.postalCode}} </span> <span>{{res.city}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.prenom'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res" class="firstName">{{res.firstname}}</mat-cell><!--(click)="SelectCustomer(res)"-->
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'scaleform.nom'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res" class="name">{{res.name}}</mat-cell><!--(click)="SelectCustomer(res)"-->
      </ng-container>

      <ng-container matColumnDef="sended">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.mailsended'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">
          <span *ngIf="res.mailSended"> {{res.dateMailSent}} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="histo">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'manageaccount.connection'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">
          {{res.nbConnection}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>{{'manageaccount.action'|translate}}</mat-header-cell>
        <mat-cell *matCellDef="let res">
          <div class="col-4">
            <div class="actionmail" *ngIf="res.mailSended" (click)="openDeleteMailModal(res)" matTooltip="{{'manageaccount.deleteDateMail'|translate}}">
              <i  aria-hidden="true" class="fal fa-recycle fa-2x primaryGrey trash"></i>
            </div>
          </div>
          <div class="col-4">
            <div class="actionhidde" *ngIf="res.ctcCreated" (click)="openDeleteAccountModal(res)" matTooltip="{{'manageaccount.hidde'|translate}}">
              <i  aria-hidden="true" class="fal fa-trash-alt fa-2x primaryGrey trash"></i>
            </div>
          </div>
        </mat-cell>
      </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
</div>

<div id="Modal" class="modal">
  <div class="modal-content" *ngIf="confirmationDeleteMail">
    <div class="col-12">
      <h3 class="modal-title text-center">{{'manageaccount.supMail'|translate}}</h3>
      <hr />
      <!--<span class="text-right  mr-2" (click)="closeModal();">
      <i  aria-hidden="true" class=" fad fa-times fa-3x close"></i>
    </span>-->
    </div>

    <!--<span class="mx-auto"><strong>{{'manageaccount.confirmDeleteMail'|translate}}</strong></span>-->
    <div class="row mt-3 mb-3">
      <span class="col-12 text-center mb-4">{{'manageaccount.confirmDeleteMail'|translate}}</span>
      <span class="col-12 text-center modal-text">{{deleteMailCustomer.socialReason | uppercase}} - {{deleteMailCustomer.firstname | titlecase}}  {{deleteMailCustomer.name | uppercase}}</span>
      <span class="col-12 text-center modal-text">{{deleteMailCustomer.mail }}</span>
    </div>
    <div class="btnConfirm row">
      <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="deleteDateMail()">{{'assistance.oui'|translate|titlecase}} </button>
      <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2" (click)="closeModal()">{{'assistance.non'|translate|titlecase}} </button>
    </div>
  </div>

  <div class="modal-content" *ngIf="confirmationDeleteAccount">
    <div class="col-12">
      <h3 class="modal-title text-center">{{'manageaccount.supAccount'|translate}}</h3>
      <hr />
      <!--<span class="text-right  mr-2" (click)="closeModal();">
      <i  aria-hidden="true" class=" fad fa-times fa-3x close"></i>
    </span>-->
    </div>
    <!--<span class="mx-auto"><strong>{{'manageaccount.confirmDeleteAccount'|translate}}</strong></span>-->
    <div class="row mt-3 mb-3">
      <span class="col-12 text-center mb-4">{{'manageaccount.confirmDeleteAccount'|translate}}</span>
      <span class="col-12 text-center modal-text">{{deleteAccountCustomer.socialReason | uppercase}} - {{deleteAccountCustomer.firstname | titlecase}}  {{deleteAccountCustomer.name | uppercase}}</span>
      <span class="col-12 text-center modal-text">{{deleteAccountCustomer.mail }}</span>
    </div>
    <div class="btnConfirm row">
      <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="hiddeCustomer()">{{'assistance.oui'|translate|titlecase}} </button>
      <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2" (click)="closeModal()">{{'assistance.non'|translate|titlecase}} </button>
    </div>
  </div>
</div>

